import { Music } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';

export function TrackSelector({ tracks, selectedTrack, onSelect }) {
  return (
    <div className="glass-card p-6">
      <h3 className="font-semibold mb-4 flex items-center gap-2">
        <Music className="w-5 h-5 text-purple-400" />
        Select Track
      </h3>
      <Select value={selectedTrack || ''} onValueChange={onSelect}>
        <SelectTrigger className="bg-white/5 border-white/10" data-testid="track-select">
          <SelectValue placeholder="Choose a track to distribute royalties" />
        </SelectTrigger>
        <SelectContent className="bg-gray-900 border-gray-700">
          {tracks.map((track) => (
            <SelectItem key={track.id} value={track.id}>
              <div className="flex items-center gap-2">
                <span className="font-medium">{track.title}</span>
                <span className="text-gray-400 text-sm">- {track.artist}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
